import { render, staticRenderFns } from "./SpamTweets.vue?vue&type=template&id=02367208&scoped=true&"
import script from "./SpamTweets.vue?vue&type=script&lang=js&"
export * from "./SpamTweets.vue?vue&type=script&lang=js&"
import style0 from "./SpamTweets.vue?vue&type=style&index=0&id=02367208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02367208",
  null
  
)

export default component.exports